/* eslint-disable
    no-param-reassign,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [require('ui/web/confirmDialog').name];

module.exports = angular
  .module('bench.ui.asyncSubmit', deps)

  .directive('blAsyncSubmit', ($parse, $timeout, $q, blConfirmService) => ({
    restrict: 'A',
    scope: false,
    require: 'form',
    link(scope, elem, attrs, form) {
      const asyncSubmit = $parse(attrs.blAsyncSubmit, null, true);

      return elem.on('submit', e => {
        e.preventDefault();
        form.$setSubmitted();
        if (!form.$valid) {
          return;
        }
        elem.addClass('bl-submitting');
        scope.$submitting = true;

        const confirmDialogPromise = (() => {
          if (attrs.blAsyncSubmitConfirm) {
            const message = attrs.blAsyncSubmitConfirm;
            return blConfirmService.openConfirm(message, attrs.blAsyncSubmitConfirmTemplate);
          }
          return $q.when(true);
        })();

        return confirmDialogPromise
          .then(() => asyncSubmit(scope, { $event: e }))
          .then(() => {
            elem.removeClass('bl-submitting');
            elem.addClass('bl-submit-success');
            scope.$submitting = false;
            form.$setPristine();

            return $timeout(() => elem.removeClass('bl-submit-success'), 2000);
          })
          .catch(() => {
            elem.removeClass('bl-submitting');
            elem.addClass('bl-submit-failure');
            scope.$submitting = false;

            return $timeout(() => elem.removeClass('bl-submit-failure'), 2000);
          });
      });
    },
  }));
